import TableHead from '@mui/material/TableHead';

export default TableHead;
